import { ArticleContentType } from '@features/article/types';

import { AdSlotRatios } from './CoolblueAds.types';

const GPT_SCRIPT_URL = 'https://pagead2.googlesyndication.com/tag/js/gpt.js';
const COOLBLUE_GPT_NETWORK_CODE = '133972167';
const ADDITIONAL_AD_SCALE_AMOUNT = 0.007;
const RESIZE_DEBOUNCE_TIME = 60;

// based on this sheet: https://docs.google.com/spreadsheets/d/1wr-kzQTp37Bb8lfKzLGNNFbCWfngvA8ju-iUXHc7Yo4/edit?gid=426927545#gid=426927545
const AD_SLOT_RATIOS_PER_TYPE = {
  primaryBanners: {
    desktop: {
      width: 618,
      height: 320
    },
    mobile: {
      width: 500,
      height: 328
    }
  },
  additionalBanners: {
    desktop: {
      width: 404,
      height: 143
    },
    mobile: {
      width: 404,
      height: 143
    }
  },
  image2entrances: {
    desktop: {
      width: 608,
      height: 261
    },
    mobile: {
      width: 375,
      height: 211
    }
  },
  // image4Entrances
  imageentrances: {
    desktop: {
      width: 694,
      height: 535
    },
    mobile: {
      width: 467,
      height: 360
    }
  },
  filterPage: {
    desktop: {
      width: 294,
      height: 396
    },
    mobile: {
      width: 480,
      height: 212
    }
  }
};

const BANNER_AD_TYPE_PER_SLOT_NAME: Record<string, AdSlotRatios> = {
  Leaderboard1A: 'primaryBanners',
  Leaderboard1B: 'primaryBanners',
  Leaderboard2: 'additionalBanners',
  Leaderboard3: 'additionalBanners',
  Leaderboard4: 'additionalBanners',
  Leaderboard5: 'additionalBanners',
  Leaderboard6: 'additionalBanners',
  Leaderboard7: 'additionalBanners'
};

const ARTICLE_CONTENT_TYPE_GROUPS = {
  brandContentTypes: [
    ArticleContentType.Brand,
    ArticleContentType.BrandCampaign,
    ArticleContentType.BrandProductType,
    ArticleContentType.BrandProductTypeCampaign,
    ArticleContentType.BrandProductTypeSegment,
    ArticleContentType.BrandProductTypeSegmentCampaign,
    ArticleContentType.ProductCollection
  ],
  brandProductContentTypes: [
    ArticleContentType.BrandProductType,
    ArticleContentType.BrandProductTypeCampaign,
    ArticleContentType.BrandProductTypeSegment,
    ArticleContentType.BrandProductTypeSegmentCampaign
  ],
  generalProductContentTypes: [
    ArticleContentType.ProductType,
    ArticleContentType.ProductTypeCampaign,
    ArticleContentType.ProductTypeSegment,
    ArticleContentType.ProductTypeSegmentCampaign
  ]
};

const BRAND_PRODUCT_TYPE_PAGE = 'Brand Product Type Page';
const GENERAL_PRODUCT_TYPE_PAGE = 'General Product Type Page';
const BRAND_PAGE = 'Brand Page';
const CLOSED_COMMUNITY_PAGE = 'Closed Community Page';

export {
  AD_SLOT_RATIOS_PER_TYPE,
  ADDITIONAL_AD_SCALE_AMOUNT,
  ARTICLE_CONTENT_TYPE_GROUPS,
  BANNER_AD_TYPE_PER_SLOT_NAME,
  BRAND_PAGE,
  BRAND_PRODUCT_TYPE_PAGE,
  CLOSED_COMMUNITY_PAGE,
  COOLBLUE_GPT_NETWORK_CODE,
  GENERAL_PRODUCT_TYPE_PAGE,
  GPT_SCRIPT_URL,
  RESIZE_DEBOUNCE_TIME
};
